export default function HelpTranslateDirective(helpTranslationService) {
  'ngInject';

  return {
    restrict: 'A',
    link: function (scope, element) {
      const input = element[0].innerText;
      if (input in helpTranslationService.translation) {
        const translateString =
          helpTranslationService.translation[input] ||
          (helpTranslationService.showMissingTag ? `[[ N/A ]] ${input}` : input);
        element.text(translateString);
      }
    },
  };
}
